import DateAgo from './DateAgo'

export * from './DateAgo'

export default DateAgo
